import { Box, Divider, TableCell, TableRow, Typography } from "@mui/material";
import AddonsSelectCheckbox from "./addons/AddonsSelectCheckbox";
import AddonsSelectQty from "./addons/AddonsSelectQty";

const AddonsItemRow = ({
  addon,
  addonQty,
  handleSelectionClick,
  setAddonSelectedQty,
  isSelected,
}) => {
  let addongroup = {
    title: "",
    disabled: true,
    addons_data: {},
    option_data: {},
  };

  if (addon != null && addon.length > 0) {
    addongroup = {
      title: addon[0]["title"],
      disabled: addon[0]["disabled"],
      addons_data: addon[0]["addons_data"],
      option_data: addon[0]["option_data"],
    };
  }

  const showQty = addongroup && addongroup?.addons_data?.optiontype === "qty";

  return (
    <Box>
      <Box sx={{ padding: 2 }}>
        <Typography sx={{ fontWeight: "bold" }}>{addongroup.title}</Typography>

        {showQty && (
          <AddonsSelectQty
            addon={addon}
            addonQty={addonQty}
            addongroup={addongroup}
            handleSelectionClick={handleSelectionClick}
            setAddonSelectedQty={setAddonSelectedQty}
            isSelected={isSelected}
          />
        )}

        {!showQty && (
          <AddonsSelectCheckbox
            addon={addon}
            addongroup={addongroup}
            setAddonSelectedQty={setAddonSelectedQty}
            handleSelectionClick={handleSelectionClick}
            isSelected={isSelected}
          />
        )}
      </Box>
      <Divider />
    </Box>
  );
};

const AddonsTable = ({ addons, onChange, addonsQty, selectedAddons }) => {
  const handleSelectionClick = (row) => {
    const wasSelected = isSelected(row);
    let newSelected;
    if (row?.addons_data?.optiontype === "singlerequired") {
      // Single selection, optional

      if (wasSelected) {
        newSelected = [...selectedAddons];
      } else {
        newSelected = [...selectedAddons].filter(
          (item) => item && item.addid !== row.addid
        );
        newSelected = [...newSelected, row];
      }
    } else if (
      row?.addons_data?.optiontype === "multiselect" ||
      row?.addons_data?.optiontype === "multiselectyes" ||
      row?.addons_data?.optiontype === "multiselectno"
    ) {
      // Multi selection, optional
      if (wasSelected) {
        newSelected = [...selectedAddons].filter(
          (item) => item && item.aoid !== row.aoid
        );
      } else {
        newSelected = [...selectedAddons, row];
      }
    } else {
      // Single selection, optional
      newSelected = [...selectedAddons].filter(
        (item) => item && item.addid !== row.addid
      );
      if (!wasSelected) {
        newSelected = [...newSelected, row];
      }
    }

    if (onChange) onChange(newSelected, addonsQty);
  };

  const setAddonSelectedQty = (row, qty) => {
    const shouldBeSelected = qty > 0;
    const wasSelected = isSelected(row);

    let newSelected = [];
    if (shouldBeSelected === wasSelected) {
      newSelected = [...selectedAddons];
    } else {
      newSelected = [...selectedAddons].filter(
        (item) => !(item && item.addid === row.addid && item.aoid === row.aoid)
      );
      if (shouldBeSelected) newSelected.push(row);
    }

    const newAddonsQty = { ...addonsQty, [row.aoid]: qty };
    if (onChange) onChange(newSelected, newAddonsQty);
  };

  const isSelected = (row) => {
    return (
      selectedAddons.filter(
        (item) => item && item.addid === row.addid && item.aoid === row.aoid
      ).length > 0
    );
  };

  return (
    <>
      {(addons || []).map((row, idx) => {
        if (row[0].disabled) {
          return (
            <TableRow key={`addonrow_${idx}`}>
              <TableCell component="th" scope="row">
                {row[0].title}
              </TableCell>
              <TableCell key={`addonbtn_empty_1`} colSpan="3" scope="row">
                <Typography color="secondary" sx={{ paddingLeft: "10px" }}>
                  Midlertidig utsolgt
                </Typography>
              </TableCell>
            </TableRow>
          );
        } else {
          return (
            <AddonsItemRow
              key={`addonrow_${idx}`}
              addon={row}
              addonQty={addonsQty}
              handleSelectionClick={handleSelectionClick}
              setAddonSelectedQty={setAddonSelectedQty}
              isSelected={isSelected}
            />
          );
        }
      })}
    </>
  );
};

export default AddonsTable;
